import { i as initialize } from './ionic-global-63a97a32.js';

const globalScripts = initialize;

export { globalScripts as g };
